import { render, staticRenderFns } from "./CustomerManagementVisionReview.vue?vue&type=template&id=48ea5855&scoped=true&"
import script from "./CustomerManagementVisionReview.vue?vue&type=script&lang=js&"
export * from "./CustomerManagementVisionReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ea5855",
  null
  
)

export default component.exports